"use client";

import Link from "next/link";

export default function Header() {
  return (
    <header className="bg-black text-white py-4 shadow-md">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-6">
        {/* Logo */}
        <Link href="/" aria-label="Flightpath Mentoring Home" className="block">
          <img
            src="/Flightpath-Mentoring-Logo.png"
            alt="Flightpath Mentoring Logo"
            className="h-12 w-auto"
          />
        </Link>

        {/* Navigation */}
        <nav className="space-x-6 text-sm font-medium">
          <Link
            href="/pilots"
            className="uppercase tracking-wide hover:text-amber-400 hover:underline transition-colors"
          >
            FOR PILOTS
          </Link>
          <Link
            href="/organisations"
            className="uppercase tracking-wide hover:text-amber-400 hover:underline transition-colors"
          >
            FOR ORGANISATIONS
          </Link>
          <Link
            href="/about"
            className="uppercase tracking-wide hover:text-amber-400 hover:underline transition-colors"
          >
            ABOUT US
          </Link>
          <Link
            href="/testimonials"
            className="uppercase tracking-wide hover:text-amber-400 hover:underline transition-colors"
          >
            TESTIMONIALS
          </Link>
          <Link
            href="/pricing"
            className="uppercase tracking-wide hover:text-amber-400 hover:underline transition-colors"
          >
            PRICING
          </Link>
          <Link
            href="/blog"
            className="uppercase tracking-wide hover:text-amber-400 hover:underline transition-colors"
          >
            INSIGHTS
          </Link>
          <Link
            href="/contact"
            className="uppercase tracking-wide border border-amber-400 rounded-xl px-3 py-1.5 hover:bg-amber-400 hover:text-black transition"
          >
            CONTACT US
          </Link>
        </nav>
      </div>
    </header>
  );
}
